import React from 'react';
import ReactClass from 'create-react-class';
import Parse from 'parse';
import RoleCell from './roleCell';

export default ReactClass({

    getInitialState() {
        return {
            projects: [],
            users: [],
        }
    },

    fetchProjectList() {

        let _this = this;
        let Project = Parse.Object.extend("Project");
        let User = Parse.Object.extend("User");

        let projectsQuery = new Parse.Query(Project).ascending("code");
        projectsQuery.notEqualTo("deleted", true);
        let usersQuery = new Parse.Query(User).ascending("username");
        usersQuery.include("info");

        Promise.all([projectsQuery.find(), usersQuery.find()]).then((results) => {

            let projects = [];
            let emptyRolesArray = [];
            results[0].forEach((project, i) => {
                projects.push({
                    id: project.id,
                    code: project.get("code"),
                });
                emptyRolesArray.push("-");
            });

            let users = [];
            results[1].forEach((user, i) => {
                let info = user.get("info");
                if (info.get("deleted") === true)return;
                users.push({
                    id: user.id,
                    name: info.get("name"),
                    email: user.get("username"),
                });
            });

            _this.setState({
                projects: projects,
                users: users.sort((a,b) => { return a.name.localeCompare(b.name) }),
            });

        });

    },

    componentDidMount() {
        this.fetchProjectList()
    },

    render() {
        return (
            <div>
                <h2>
                    Roles
                </h2>
                {
                    this.state.projects.length > 0 ? (
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th>Code</th>
                                {this.state.projects.map(project => {
                                    return (
                                        <th key={"rprj" + project.id}>{project.code}</th>
                                    );
                                })}
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.users.map((user) => {
                                return (
                                    <tr key={user.id}>
                                        <th>{user.name}</th>
                                        {this.state.projects.map((project) => {
                                            return (
                                            <RoleCell key={project.id+user.id} project={project} user={user} />
                                            )
                                        })}
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    ) : (
                        <em>No roles found.<br /><br /></em>
                    )
                }
            </div>
        );
    },

});


// WEBPACK FOOTER //
// ./src/roles.js